import React from 'react';
import './Footer.css';
import { BUILD_ENV } from '../../const/ConstBase';

export const Footer = () => {
    return (
        <div
            className='maindiv'
            style={{ width: '100%', height: '100%', background: '#000000' }}
        >
            <div
                className='text-center'
                style={{
                    paddingTop: 40,
                    marginTop: 0,
                    paddingBottom: 45,
                    borderTop: '1px solid rgb(18,18,18)',
                }}
            >
                <div
                    style={{
                        color: 'rgb(90,90,90)',
                    }}
                >
                    NETDOOR INC. 3012 Murray St, Port Moody, BC, Canada
                    <br />
                    Tel : 754. 279. 8245, Eun yong Cho
                    <br />
                    Business Number : 747119220BC0001
                </div>
            </div>
        </div>
    );
};
